import React from 'react';

export type TurboLiveContextType = {
    addPick: (betId: string, selectionCode: number, odds: number, sectionOrigin: any, additionalAction?: any) => void;
    removePick: (betId: string) => void;
    isPickSelectedSub$$: (betId: string, selectionCode: number) => any;
    showLoginModal: (redirect?: string) => void;
    startCashinOfferSubscription: () => void;
    stopCashinOfferSubscription: () => void;
    openCashinDialog: (ticketId: string, ref: any, cashinPosition?: string) => any;
    openAutoCashinDialog: (ticketId: string, ref: any, cashinPosition?: string) => any;
    useLoadMatchtrackerInfo: (boxIds: any, tournamentIds: any) => any;
    startBetradarMT: (match: any, streamType: string, checkTicketActive?: boolean) => any;
    getBetbookPosts: (matchId: string) => any;
    getNextMatchData: () => any;
    getActiveTickets: () => any;
    getActiveMatchTickets: (matchId: string) => any;
    ticketsTable: (matchId: string, source: string) => React.FunctionComponent<any>;
    marketStatisticsBox: (
        matchId: string,
        sportId: string,
        live: boolean,
        market: string
    ) => React.FunctionComponent<any>;
    betbookPostsBox: (post: any, detail: boolean) => React.FunctionComponent<any>;
    MatchNotificationBox: (matchId, sportId) => any;
    showTooltip: (text: string) => any;
};

const TurboLiveContext = React.createContext<TurboLiveContextType>({
    addPick: () => {},
    removePick: () => {},
    isPickSelectedSub$$: () => null,
    showLoginModal: () => {},
    startCashinOfferSubscription: () => {},
    stopCashinOfferSubscription: () => {},
    openCashinDialog: () => {},
    openAutoCashinDialog: () => {},
    useLoadMatchtrackerInfo: () => {},
    startBetradarMT: () => {},
    getBetbookPosts: () => {},
    getNextMatchData: () => {},
    getActiveTickets: () => {},
    getActiveMatchTickets: () => {},
    ticketsTable: () => null,
    marketStatisticsBox: () => null,
    betbookPostsBox: () => null,
    MatchNotificationBox: () => null,
    showTooltip: () => {}
});
export default TurboLiveContext;
